/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {ObjectService} from "../services/object.service";
import { Input, Injectable } from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {ObjectCategory} from "../models/object-category";
import {PropertyDescription} from "../models/propertyDescription";

@Injectable()
export class PeopleObjectParametersResolver implements Resolve<PropertyDescription[]> {

  constructor(
    private mObjectService: ObjectService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PropertyDescription[]> {
    try {
      const functionParameters = [];

      //const objects = await this.mObjectService.getAllObjectsForCategory(ObjectCategory.PEOPLE);
      //if (objects) {
      //  for (const object of objects) {
      //    // Grab individual object - as the list itself does not contain the properties
      //    const objectWithProperties = await this.mObjectService.getObjectForId(object.id);
      //    if (objectWithProperties.properties && objectWithProperties.properties.length > 0) {
      //      for (const property of objectWithProperties.properties) {
      //        const propertyDescription = new PropertyDescription();
      //        propertyDescription.parentName = objectWithProperties.name;
      //        propertyDescription.name = property.name;
      //        functionParameters.push(propertyDescription);
      //      }
      //    }
      //  }
      //} else {
      //  console.error("People objects empty");
      //}
      return functionParameters;    } catch (error) {
      console.error("Problem resolving People Objects... Error: " + error, error);
    }
  }

}
